/* Gulppp product options - replaces the "PC - Product Options" app (built 23.10.26).
   - Option lists live in assets/gulppp-options-config.js (window.GP_OPTIONS, keyed by product handle).
   - Choices are saved on the order line as line item properties (same names the app used).
   - Paid choices are charged with variants of the hidden, unlisted product "Add-on"
     (handle gulppp-add-on). Variant names are "<option name>: <choice>" (plus " (£x.xx)" when the
     same choice has different prices on different products). They are added to the basket as
     nested lines under the product, so they are removed with it, and their quantity follows it.
   - Loaded on every page by snippets/gulppp-options.liquid (rendered from layout/theme.liquid). */
(function () {
  'use strict';
  if (window.__gpOptionsLoaded) return;
  window.__gpOptionsLoaded = true;

  var ADDON = 'gulppp-add-on';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);

  function money(p) { return '£' + (p / 100).toFixed(2); }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v === true) e.setAttribute(k, '');
        else if (v !== null && v !== undefined && v !== false && v !== '') e.setAttribute(k, v);
      }
    }
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }

  /* ---------- add-on variants (prices) ---------- */
  var addonPromise = null;
  function addonVariants() {
    if (!addonPromise) {
      addonPromise = origFetch(root + 'products/' + ADDON + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('addon ' + r.status); return r.json(); })
        .then(function (p) { return p.variants || []; });
      addonPromise.catch(function () { addonPromise = null; });
    }
    return addonPromise;
  }
  function findVariant(vs, name, value, pence) {
    var base = norm(name + ': ' + value), alt = norm(name + ': ' + value + ' (' + money(pence) + ')');
    for (var i = 0; i < vs.length; i++) {
      var t = norm(vs[i].title);
      if ((t === base || t === alt) && vs[i].price === pence && vs[i].available !== false) return vs[i];
    }
    return null;
  }

  /* ---------- product page fields ---------- */
  function priceText(p) { return p ? ' (+' + money(p) + ')' : ''; }

  function render(cfg) {
    var box = el('div', { 'class': 'gp-options' });
    cfg.forEach(function (o, i) {
      var id = 'gp-opt-' + i;
      var wrap = el('div', { 'class': 'gp-opt gp-type-' + o.t });
      var lab = el('label', { 'class': 'gp-label', 'for': id }, o.l + priceText(o.lp));
      if (o.r) { lab.appendChild(document.createTextNode(' ')); lab.appendChild(el('span', { 'class': 'gp-req', 'aria-hidden': 'true' }, '*')); }
      wrap.appendChild(lab);
      if (o.d) wrap.appendChild(el('p', { 'class': 'gp-desc' }, o.d));
      var name = 'properties[' + o.n + ']';
      var input = null;
      if (o.t === 'text') {
        input = el('input', { type: 'text', id: id, name: name, required: !!o.r, maxlength: o.max || null, placeholder: o.ph || null });
      } else if (o.t === 'multiline') {
        input = el('textarea', { id: id, name: name, required: !!o.r, maxlength: o.max || null, placeholder: o.ph || null, rows: '3' });
      } else if (o.t === 'file') {
        input = el('input', { type: 'file', id: id, name: name, required: !!o.r });
      } else if (o.t === 'select') {
        input = el('select', { id: id, name: name, required: !!o.r });
        if (o.sp) { var ph = el('option', null, 'Please choose one'); ph.setAttribute('value', ''); input.appendChild(ph); }
        (o.o || []).forEach(function (v) { input.appendChild(el('option', { value: v[0] }, v[0] + priceText(v[1]))); });
      } else if (o.t === 'checkbox_group') {
        input = el('input', { type: 'hidden', id: id, name: name, disabled: true });
        var group = el('div', { 'class': 'gp-checks', role: 'group' });
        (o.o || []).forEach(function (v, j) {
          var l = el('label', { 'class': 'gp-check' });
          l.appendChild(el('input', { type: 'checkbox', 'data-j': String(j) }));
          l.appendChild(document.createTextNode(v[0] + priceText(v[1])));
          group.appendChild(l);
        });
        wrap.appendChild(group);
      }
      if (input) { input.setAttribute('data-gp-i', String(i)); wrap.appendChild(input); }
      box.appendChild(wrap);
    });
    enhance(box, cfg);
    box.appendChild(el('p', { 'class': 'gp-total', hidden: true }));
    box.appendChild(el('p', { 'class': 'gp-error', role: 'alert', hidden: true }));
    return box;
  }



  /* ---------- redesign 2026: pill buttons for short choice lists + live sign preview ---------- */
  function enhance(box, cfg) {
    box.appendChild(el('p', { 'class': 'gp-desc gp-ship' }, 'Printed to order · Dispatched in 1–3 working days · Free UK delivery'));
    cfg.forEach(function (o, i) {
      if (o.t !== 'select' || !o.o || o.o.length > 6) return;
      var sel = box.querySelector('[data-gp-i="' + i + '"]');
      if (!sel) return;
      var wrap = sel.closest('.gp-opt');
      var lab = wrap.querySelector('.gp-label');
      var pills = el('div', { 'class': 'gp-pills', role: 'group' });
      if (lab) { lab.removeAttribute('for'); lab.id = 'gp-lab-' + i; pills.setAttribute('aria-labelledby', lab.id); }
      o.o.forEach(function (v) {
        var b = el('button', { type: 'button', 'class': 'gp-pill', 'aria-pressed': 'false', 'data-v': v[0] }, v[0] + (v[1] ? ' +' + money(v[1]) : ''));
        b.addEventListener('click', function () {
          sel.value = v[0];
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
        pills.appendChild(b);
      });
      function sync() {
        var bs = pills.querySelectorAll('.gp-pill');
        for (var k = 0; k < bs.length; k++) bs[k].setAttribute('aria-pressed', bs[k].getAttribute('data-v') === sel.value ? 'true' : 'false');
      }
      sel.addEventListener('change', sync);
      sel.classList.add('gp-sr');
      sel.setAttribute('tabindex', '-1');
      sel.setAttribute('aria-hidden', 'true');
      sel.__gpPills = pills;
      wrap.insertBefore(pills, sel);
      sync();
    });

    // Live preview for signs: needs a "Text Above", a "Text Below" and a file field.
    var top = -1, bottom = -1, file = -1;
    cfg.forEach(function (o, i) {
      if (o.t === 'text' && /above/i.test(o.n)) top = i;
      else if (o.t === 'text' && /below/i.test(o.n)) bottom = i;
      else if (o.t === 'file' && file < 0) file = i;
    });
    if (top < 0 || bottom < 0 || file < 0) return;
    var pv = el('div', { 'class': 'gp-preview', 'aria-live': 'polite' });
    var sign = el('div', { 'class': 'gp-preview__sign', 'aria-hidden': 'true' });
    var tTop = el('span', { 'class': 'gp-preview__top' }, 'The Red Lion');
    var img = el('img', { alt: '', width: '110', height: '110' });
    img.src = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="110" height="110"><rect width="110" height="110" fill="#2A2A2A"/><text x="55" y="60" fill="#D9BC74" font-family="Georgia" font-size="12" text-anchor="middle">Your photo</text></svg>');
    var tBot = el('span', { 'class': 'gp-preview__bottom' }, 'Est. 2026');
    sign.appendChild(tTop); sign.appendChild(img); sign.appendChild(tBot);
    pv.appendChild(sign);
    pv.appendChild(el('p', { 'class': 'gp-preview__note' }, 'A quick preview of your words and photo. We lay out every sign by hand and email you a proof if anything needs checking.'));
    var first = box.querySelector('[data-gp-i="' + top + '"]').closest('.gp-opt');
    box.insertBefore(pv, first);
    var inTop = box.querySelector('[data-gp-i="' + top + '"]');
    var inBot = box.querySelector('[data-gp-i="' + bottom + '"]');
    var inFile = box.querySelector('[data-gp-i="' + file + '"]');
    inTop.addEventListener('input', function () { tTop.textContent = inTop.value || 'The Red Lion'; });
    inBot.addEventListener('input', function () { tBot.textContent = inBot.value || 'Est. 2026'; });
    inFile.addEventListener('change', function () {
      var f = inFile.files && inFile.files[0];
      if (!f || !/^image\//.test(f.type) || !window.FileReader) return;
      var r = new FileReader();
      r.onload = function () { img.src = r.result; };
      r.readAsDataURL(f);
    });
  }

  /* Returns the paid choices currently selected: [{n, v, p}] and keeps checkbox values in sync. */
  function selections(st) {
    var picks = [];
    st.cfg.forEach(function (o, i) {
      var inp = st.box.querySelector('[data-gp-i="' + i + '"]');
      if (!inp) return;
      if (o.t === 'select') {
        var val = inp.value;
        if (!val) return;
        for (var k = 0; k < (o.o || []).length; k++) {
          if (o.o[k][0] === val) { if (o.o[k][1]) picks.push({ n: o.n, v: val, p: o.o[k][1] }); break; }
        }
      } else if (o.t === 'checkbox_group') {
        var vals = [];
        var boxes = inp.closest('.gp-opt').querySelectorAll('input[type=checkbox]');
        for (var c = 0; c < boxes.length; c++) {
          if (!boxes[c].checked) continue;
          var opt = o.o[+boxes[c].getAttribute('data-j')];
          vals.push(opt[0]);
          if (opt[1]) picks.push({ n: o.n, v: opt[0], p: opt[1] });
        }
        inp.value = vals.join(', ');
        inp.disabled = !vals.length;
      } else if (o.t === 'file') {
        if (o.lp && inp.files && inp.files.length) picks.push({ n: o.n, v: 'Artwork uploaded', p: o.lp });
      }
    });
    return picks;
  }

  function updateTotal(st) {
    var picks = selections(st), sum = 0;
    picks.forEach(function (x) { sum += x.p; });
    var t = st.box.querySelector('.gp-total');
    t.hidden = !sum;
    t.textContent = sum ? 'Selected options: +' + money(sum) : '';
  }

  function checkGroups(st) {
    var ok = true;
    st.cfg.forEach(function (o, i) {
      if (o.t !== 'checkbox_group') return;
      var wrap = st.box.querySelector('[data-gp-i="' + i + '"]').closest('.gp-opt');
      var boxes = wrap.querySelectorAll('input[type=checkbox]');
      var any = false;
      for (var c = 0; c < boxes.length; c++) if (boxes[c].checked) any = true;
      if (boxes[0]) boxes[0].setCustomValidity(o.r && !any ? 'Please choose at least one option.' : '');
      if (o.r && !any && ok) { boxes[0].reportValidity(); ok = false; }
    });
    return ok;
  }

  function setLoading(btn, on) {
    if (!btn) return;
    var sp = btn.querySelector('.loading__spinner, .loading-overlay__spinner');
    if (on) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); if (sp) sp.classList.remove('hidden'); }
    else { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); if (sp) sp.classList.add('hidden'); }
  }

  function showError(st, msg) {
    var pf = st.form.closest('product-form');
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    var m = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && m) {
      if (msg) wrap.removeAttribute('hidden'); else wrap.setAttribute('hidden', '');
      m.textContent = msg || '';
    }
    var own = st.box.querySelector('.gp-error');
    own.hidden = !msg || !!(wrap && m);
    own.textContent = msg || '';
  }

  function jsonPost(url, body) {
    return origFetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function cartSections(cart) {
    try { return cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : []; }
    catch (e) { return []; }
  }

  function submit(st) {
    var form = st.form;
    var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    var fields = st.box.querySelectorAll('input, select, textarea');
    for (var q = 0; q < fields.length; q++) {
      if (fields[q].disabled || fields[q].checkValidity()) continue;
      if (fields[q].__gpPills) {
        var lb = fields[q].closest('.gp-opt').querySelector('.gp-label');
        showError(st, 'Please choose: ' + (lb ? lb.textContent.replace(/\s*\*$/, '') : 'an option'));
        fields[q].__gpPills.querySelector('.gp-pill').focus();
      } else fields[q].reportValidity();
      return;
    } if (!checkGroups(st)) return;
    var picks = selections(st);
    setLoading(btn, true);
    showError(st, null);

    var mainItem = null, qty = 1;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    (picks.length ? addonVariants() : Promise.resolve([]))
      .then(function (vs) {
        var lines = {}, order = [];
        picks.forEach(function (x) {
          var v = findVariant(vs, x.n, x.v, x.p);
          if (!v) throw new Error('Sorry, "' + x.n + ': ' + x.v + '" can’t be added right now. Please contact info@gulppp.com and we will sort it for you.');
          if (!lines[v.id]) { lines[v.id] = 0; order.push(v.id); }
          lines[v.id] += 1;
        });
        var fd = new FormData(form);
        qty = parseInt(fd.get('quantity'), 10) || 1;
        var addUrl = (window.routes && window.routes.cart_add_url) || (root + 'cart/add');
        return origFetch(addUrl, {
          method: 'POST', credentials: 'same-origin', body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
        }).then(function (r) { return r.json(); }).then(function (item) {
          if (item.status) throw new Error(item.description || item.message || 'Sorry, this could not be added to your basket.');
          mainItem = item;
          var sections = cartSections(cart);
          if (order.length) {
            var items = order.map(function (id) {
              var it = { id: id, quantity: lines[id] * qty, parent_line_key: item.key };
              if (lines[id] > 1) it.properties = { _per: String(lines[id]) };
              return it;
            });
            var body = { items: items };
            if (sections.length) { body.sections = sections.join(','); body.sections_url = location.pathname; }
            return jsonPost(root + 'cart/add.js', body).then(function (res) {
              if (res.status) {
                return jsonPost(root + 'cart/change.js', { id: item.key, quantity: Math.max(0, item.quantity - qty) })
                  .then(function () { throw new Error(res.description || 'Sorry, the selected options could not be added.'); });
              }
              return res.sections || null;
            });
          }
          if (!sections.length) return null;
          return origFetch(root + '?sections=' + sections.join(','), { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        });
      })
      .then(function (sections) {
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: mainItem.variant_id, cartData: mainItem });
          }
        } catch (e) { /* ignore */ }
        if (!cart || !sections) { location.href = (window.routes && window.routes.cart_url) || (root + 'cart'); return; }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        var state = {};
        for (var k in mainItem) if (Object.prototype.hasOwnProperty.call(mainItem, k)) state[k] = mainItem[k];
        state.sections = sections;
        cart.renderContents(state);
      })
      .catch(function (er) { showError(st, (er && er.message) || String(er)); })
      .then(function () { setLoading(btn, false); });
  }

  function findForm() {
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"], form[action$="/cart/add"]');
    var fallback = null;
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('quick-add-modal, .quick-add-modal, product-modal, .product-popup-modal')) continue;
      var fid = f.getAttribute('id') || ''; if (/installment/.test(fid)) continue; if (/^product-form-template/.test(fid) || f.getAttribute('data-type') === 'add-to-cart-form') return f;
      if (!fallback && f.closest('product-info, .product')) fallback = f;
    }
    return fallback;
  }

  var state = null;
  function mount() {
    var all = window.GP_OPTIONS, prod = window.GP_PRODUCT;
    var key = all && prod ? (all[prod.handle] ? prod.handle : (prod.type && all['type:' + prod.type] ? 'type:' + prod.type : null)) : null;
    if (!key) return;
    var form = findForm();
    if (!form) return;
    // Remove the old app's fields if they are still on the page (preview / switch-over).
    var old = document.querySelectorAll('.product-customizer-content, .product-customizer-options');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    if (state && state.form === form && state.box.isConnected) return;
    var cfg = all[key];
    var box = state && state.form === form ? state.box : render(cfg);
    var anchor = form.querySelector('.product-form__buttons');
    if (anchor && anchor.parentNode === form) form.insertBefore(box, anchor);
    else if (anchor) anchor.parentNode.insertBefore(box, anchor);
    else form.appendChild(box);
    // "Buy it now" / Shop Pay would skip the options and their charges, so hide it on these products.
    var pay = form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout');
    for (var p = 0; p < pay.length; p++) pay[p].style.display = 'none';
    var st = { form: form, box: box, cfg: cfg };
    if (!state || state.box !== box) {
      box.addEventListener('change', function () { updateTotal(st); });
      box.addEventListener('input', function () { updateTotal(st); });
    }
    form.__gp = st;
    state = st;
    updateTotal(st);
    if (cfg.some(function (o) { return (o.o || []).some(function (v) { return v[1]; }) || o.lp; })) addonVariants().catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.__gp) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submit(form.__gp);
  }, true);

  /* ---------- basket: keep add-on quantities matched to their product ---------- */
  var reconciling = false, again = false;
  function reconcile() {
    if (reconciling) { again = true; return; }
    reconciling = true;
    origFetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byKey = {}, fixes = [];
        (cart.items || []).forEach(function (it) { byKey[it.key] = it; });
        (cart.items || []).forEach(function (it) {
          if (it.handle !== ADDON) return;
          var pk = it.parent_relationship && it.parent_relationship.parent_key;
          var parent = pk ? byKey[pk] : null;
          var per = parseInt((it.properties && it.properties._per) || '1', 10) || 1;
          var want = parent ? parent.quantity * per : 0;
          if (it.quantity !== want) fixes.push({ id: it.key, quantity: want });
        });
        if (!fixes.length) return false;
        return fixes.reduce(function (pr, f) {
          return pr.then(function () { return jsonPost(root + 'cart/change.js', f); });
        }, Promise.resolve()).then(function () { return true; });
      })
      .then(function (changed) {
        if (!changed) return;
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        var cd = document.querySelector('cart-drawer');
        var ids = cartSections(cd);
        if (!cd || !ids.length) return;
        return origFetch(root + '?sections=' + ids.join(','), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (secs) {
            ids.forEach(function (id) {
              var s = cd.getSectionsToRender().filter(function (x) { return x.id === id; })[0];
              var target = s && s.selector ? document.querySelector(s.selector) : document.getElementById(id);
              if (target && secs[id] && cd.getSectionInnerHTML) target.innerHTML = cd.getSectionInnerHTML(secs[id], s && s.selector);
            });
          });
      })
      .catch(function () { /* ignore */ })
      .then(function () { reconciling = false; if (again) { again = false; setTimeout(reconcile, 100); } });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var pr = origFetch(input, init);
    if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      pr.then(function () { setTimeout(reconcile, 300); }, function () {});
    }
    return pr;
  };

  function start() {
    mount();
    setInterval(mount, 1500); // re-attach if the theme re-renders the product form (e.g. variant change)
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
